module.exports = __webpack_public_path__ + "static/media/profile.0746f071.svg";